import { Button } from '@/components/ui/button';
import { Settings, RefreshCw, UserCheck, Truck, XCircle, FileText, Zap } from 'lucide-react';

export default function DispatchToolbar({
  selectedDriverId, selectedLoadIds,
  onSettings, onRefresh, onAssign, onDispatch, onCancel, onAutoScore,
}) {
  const hasDriver = !!selectedDriverId;
  const hasLoads = selectedLoadIds.size > 0;
  const canAssign = hasDriver && hasLoads;

  return (
    <div className="flex items-center gap-1.5 px-3 py-2 border-b border-border bg-card flex-wrap">
      <Button
        variant="outline" size="sm"
        className="border-input text-muted-foreground h-8 text-xs gap-1.5"
        onClick={onSettings}
      >
        <Settings className="w-3.5 h-3.5" /> Settings
      </Button>

      <Button
        variant="outline" size="sm"
        className="border-input text-muted-foreground h-8 text-xs gap-1.5"
        onClick={onRefresh}
      >
        <RefreshCw className="w-3.5 h-3.5" /> Refresh
      </Button>

      <div className="w-px h-6 bg-input mx-1" />

      <Button
        size="sm"
        className="bg-brand-accent text-brand-accent-foreground h-8 text-xs gap-1.5 disabled:opacity-40"
        disabled={!canAssign}
        onClick={onAssign}
      >
        <UserCheck className="w-3.5 h-3.5" /> Assign
      </Button>

      <Button
        size="sm"
        className="bg-emerald-600 text-foreground h-8 text-xs gap-1.5 disabled:opacity-40"
        disabled={!canAssign}
        onClick={onDispatch}
      >
        <Truck className="w-3.5 h-3.5" /> Dispatch
      </Button>

      <Button
        variant="outline" size="sm"
        className="border-input text-muted-foreground h-8 text-xs gap-1.5 disabled:opacity-40"
        disabled={!hasLoads}
        onClick={onCancel}
      >
        <XCircle className="w-3.5 h-3.5" /> Cancel
      </Button>

      <div className="w-px h-6 bg-input mx-1" />

      <Button
        variant="outline" size="sm"
        className="border-input text-muted-foreground h-8 text-xs gap-1.5 disabled:opacity-40"
        disabled={!hasLoads || selectedLoadIds.size !== 1}
        onClick={() => {
          const loadId = [...selectedLoadIds][0];
          if (loadId) onAutoScore(loadId);
        }}
      >
        <Zap className="w-3.5 h-3.5" /> Score Drivers
      </Button>

      <Button
        variant="outline" size="sm"
        className="border-input text-muted-foreground h-8 text-xs gap-1.5 opacity-40 cursor-not-allowed"
        disabled
      >
        <FileText className="w-3.5 h-3.5" /> Waybill
      </Button>

      {/* Selection summary */}
      <div className="ml-auto text-[10px] text-muted-foreground">
        {hasDriver && <span className="text-brand-accent">Driver selected</span>}
        {hasDriver && hasLoads && <span> | </span>}
        {hasLoads && <span>{selectedLoadIds.size} load(s) selected</span>}
      </div>
    </div>
  );
}
